import React from "react";
import { useState, useEffect } from "react";
import { api } from "../../api/client";
import { timePattern, timeRegex } from "../../pages/AdminDashboard";

const TabScheduling = () => {
  const [allUsers, setAllUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [scheduleUser, setScheduleUser] = useState(null);
  const [editSchedule, setEditSchedule] = useState([]);
  const [changeRequests, setChangeRequests] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isTemporary, setIsTemporary] = useState(false);

  const load = async () => {
    const all = await api("/admin/users/all");
    setAllUsers(all.users);
  };
  
  useEffect(() => {
    load();
    loadChangeRequests();
  }, []);

  const loadChangeRequests = async () => {
    const r = await api("/admin/schedule/change-requests");
    setChangeRequests(r.requests);
  };
  const approveDay = async (userId, day) => {
    await api(`/admin/schedule/${userId}/${day}/approve`, { method: "POST" });
    loadChangeRequests();
  };
  const rejectDay = async (userId, day) => {
    await api(`/admin/schedule/${userId}/${day}/reject`, { method: "POST" });
    loadChangeRequests();
  };
  const saveSchedule = async () => {
    try {
      const scheduleToSave = editSchedule.map((d) => {
        const originalDay = scheduleUser.schedule.find(sd => sd.day === d.day);
        const scheduleDay = {
          day: d.day,
          morning: d.off ? null : d.morning,
          evening: d.off ? null : d.evening,
          off: d.off,
          pendingChange: false,
          requested: null,
        };
        
        if (isTemporary && originalDay) {
          const hasChange = 
            d.off !== originalDay.off ||
            d.morning !== originalDay.morning ||
            d.evening !== originalDay.evening;
          
          if (hasChange) {
            scheduleDay.temporaryChange = {
              originalMorning: originalDay.morning,
              originalEvening: originalDay.evening,
              originalOff: originalDay.off,
              revertAt: new Date(Date.now() + 24 * 60 * 60 * 1000),
            };
          } else {
            scheduleDay.temporaryChange = originalDay.temporaryChange || null;
          }
        } else {
          scheduleDay.temporaryChange = null;
        }
        
        return scheduleDay;
      });
      
      await api(`/admin/users/${selectedUserId}/schedule`, {
        method: "POST",
        body: { schedule: scheduleToSave },
      });
      setIsEditing(false);
      setIsTemporary(false);
      fetchSchedule();
      alert("Schedule saved successfully");
    } catch (error) {
      try {
        const message =
          "Error! Check times in HH:mm, 24-hour format and that evening is after morning.";
        alert(message);
        console.error(
          message || "Error saving schedule: Please check your inputs."
        );
      } catch (err) {
        console.error(err);
      }
    }
  };
  const fetchSchedule = async () => {
    if (!selectedUserId) return;
    const r = await api(`/admin/users/${selectedUserId}/schedule`);
    setScheduleUser(r.user);
    setEditSchedule(r.user.schedule.map((d) => ({ ...d })));
    setIsEditing(false);
    setIsTemporary(false);
  };
  return (
    <div className="card">
      <div>
        <h4>Schedule Change Requests</h4>
        <div className="scroll-x" style={{ marginBottom: 10 }}>
          <table className="table">
            <thead>
              <tr>
                <th>User</th>
                <th>Email</th>
                <th>Day</th>
                <th>Current</th>
                <th>Requested</th>
                <th>Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {changeRequests && changeRequests.length === 0 && (
                <tr>
                  <td colSpan={7}>No pending requests</td>
                </tr>
              )}
              {changeRequests &&
                changeRequests.map((r) => (
                  <tr key={r.id}>
                    <td>{r.name}</td>
                    <td>{r.email}</td>
                    <td>{r.day}</td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <span className="tag">
                          Off: {r.current.off ? "Yes" : "No"}
                        </span>
                        {r.current.morning && (
                          <span className="tag">
                            Morning: {r.current.morning || "-"}
                          </span>
                        )}
                        {r.current.evening && (
                          <span className="tag">
                            Evening: {r.current.evening || "-"}
                          </span>
                        )}
                      </div>
                    </td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <span className="tag">
                          Off: {r.requested.off ? "Yes" : "No"}
                        </span>
                        <span className="tag">
                          Morning: {r.requested.morning || "same"}
                        </span>
                        <span className="tag">
                          Evening: {r.requested.evening || "same"}
                        </span>
                      </div>
                    </td>
                    <td>
                      <span
                        className={`badge ${
                          r.requested.isTemporary ? "pending" : "approved"
                        }`}
                      >
                        {r.requested.isTemporary ? "Temporary" : "Permanent"}
                      </span>
                    </td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 4,
                        }}
                      >
                        <button
                          className="btn success"
                          style={{
                            fontSize: ".65rem",
                            padding: ".35rem .55rem",
                          }}
                          onClick={() => approveDay(r.userId, r.day)}
                        >
                          Approve
                        </button>
                        <button
                          className="btn warn"
                          style={{
                            fontSize: ".65rem",
                            padding: ".35rem .55rem",
                          }}
                          onClick={() => rejectDay(r.userId, r.day)}
                        >
                          Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div className="divider" />
        <h4>Passenger Schedule</h4>
        <form
          className="input-row"
          style={{ gap: 8, marginBottom: 8 }}
          onSubmit={(e) => {
            e.preventDefault();
            fetchSchedule();
          }}
        >
          <select
            value={selectedUserId}
            onChange={(e) => setSelectedUserId(e.target.value)}
            required
          >
            <option value="">Select Passenger Email</option>
            {allUsers
              .filter((u) => u.role === "passenger" && u.status === "approved")
              .map((u) => (
                <option key={u._id} value={u._id}>
                  {u.name} ({u.email})
                </option>
              ))}
          </select>
          <button className="btn" type="submit">
            Fetch Schedule
          </button>
        </form>
        {scheduleUser && (
          <div>
            <h5>
              {scheduleUser.name} ({scheduleUser.email})
            </h5>
            {!isEditing && (
              <button className="btn" onClick={() => setIsEditing(true)}>
                Edit Schedule
              </button>
            )}
            {isEditing && (
              <div style={{ marginBottom: "1rem" }}>
                <div style={{ display: "flex", gap: 8, marginBottom: "0.75rem" }}>
                  <button
                    className="btn success"
                    onClick={saveSchedule}
                    type="button"
                  >
                    Save Schedule
                  </button>
                  <button
                    className="btn"
                    onClick={() => {
                      setIsEditing(false);
                      setIsTemporary(false);
                      setEditSchedule(scheduleUser.schedule.map((d) => ({ ...d })));
                    }}
                    type="button"
                    style={{ background: "#999" }}
                  >
                    Cancel
                  </button>
                </div>
                <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  <input
                    type="checkbox"
                    checked={isTemporary}
                    onChange={(e) => setIsTemporary(e.target.checked)}
                  />
                  <span>Temporary Change (will revert after 24 hours)</span>
                </label>
              </div>
            )}
            <div className="scroll-x">
              <table className="table">
                <thead>
                  <tr>
                    <th>Day</th>
                    <th>Off</th>
                    <th>Morning</th>
                    <th>Evening</th>
                    <th>Temporary Change</th>
                  </tr>
                </thead>
                <tbody>
                  {editSchedule.map((d, i) => {
                    const isOff = !!d.off;
                    return (
                      <tr key={d.day}>
                        <td>{d.day}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={isOff}
                            onChange={(e) => {
                              if (!isEditing) return;
                              const v = e.target.checked;
                              setEditSchedule((f) =>
                                f.map((x, j) =>
                                  j === i ? { ...x, off: v } : x
                                )
                              );
                            }}
                            disabled={!isEditing}
                          />
                        </td>
                        <td>
                          <input
                            value={d.morning || ""}
                            onChange={(e) => {
                              if (!isEditing) return;
                              const v = e.target.value;
                              setEditSchedule((f) =>
                                f.map((x, j) =>
                                  j === i ? { ...x, morning: v } : x
                                )
                              );
                            }}
                            placeholder={ isOff ? "Day is off" : "HH:mm (24-hr)" }
                            pattern={timePattern}
                            disabled={isOff || !isEditing}
                            style={{
                              borderColor:
                                d.morning && !timeRegex.test(d.morning)
                                  ? "red"
                                  : undefined,
                                ...(isOff ? { backgroundColor: "#c2c2c2", cursor: "not-allowed" } : {}),
                            }}
                            title={
                              d.morning && !timeRegex.test(d.morning)
                                ? "Format must be HH:mm (e.g. 08:30)"
                                : ""
                            }
                          />
                          {d.morning && !timeRegex.test(d.morning) && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "0.8em",
                              }}
                            >
                              Invalid time (24-hr)
                            </span>
                          )}
                        </td>
                        <td>
                          <input
                            value={d.evening || ""}
                            onChange={(e) => {
                              if (!isEditing) return;
                              const v = e.target.value;
                              setEditSchedule((f) =>
                                f.map((x, j) =>
                                  j === i ? { ...x, evening: v } : x
                                )
                              );
                            }}
                            placeholder={isOff ? "Day is off" : "HH:mm (24-hr)"}
                            pattern={timePattern}
                            disabled={isOff || !isEditing}
                            style={{
                              borderColor:
                                d.evening && !timeRegex.test(d.evening)
                                  ? "red"
                                  : undefined,
                                  ...(isOff ? { backgroundColor: "#c2c2c2", cursor: "not-allowed" } : {}),
                            }}
                            title={
                              d.evening && !timeRegex.test(d.evening)
                                ? "Format must be HH:mm (e.g. 17:30)"
                                : ""
                            }
                          />
                          {d.evening && !timeRegex.test(d.evening) && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "0.8em",
                              }}
                            >
                              Invalid time (24-hr)
                            </span>
                          )}
                        </td>
                        <td>
                          {d.temporaryChange ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                              }}
                            >
                              <span style={{ fontSize: "0.85em" }}>
                                Reverts:{" "}
                                {new Date(d.temporaryChange.revertAt).toLocaleString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </span>
                              <span style={{ fontSize: "0.85em" }}>
                                Original: {d.temporaryChange.originalOff ? "OFF" : `${d.temporaryChange.originalMorning || "-"} - ${d.temporaryChange.originalEvening || "-"}`}
                              </span>
                              <button
                                className="btn warn"
                                style={{
                                  fontSize: ".65rem",
                                  padding: ".35rem .55rem",
                                }}
                                onClick={async () => {
                                  await api(`/admin/schedule/${selectedUserId}/${d.day}/revert`, {
                                    method: "POST",
                                  });
                                  fetchSchedule();
                                }}
                              >
                                Revert Now
                              </button>
                            </div>
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                  );
                })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TabScheduling;